import { Radio, Checkbox, Flex } from 'antd'

import { QuestionResponse, QuestionType } from 'src/api/requests'
import { Text } from 'src/components'

type Props = {
  question: QuestionResponse
  previewLang: 'ro' | 'ru'
}

type AnswerChoiceWithSelection = NonNullable<
  QuestionResponse['answerChoices']
>[number] & {
  isSelected: boolean
}

export const DetailsAnswerCard = ({ question, previewLang }: Props) => {
  const isSingleChoice = question.type === QuestionType.SINGLE_CHOICE

  const answerChoicesWithSelection: AnswerChoiceWithSelection[] = (
    question.answerChoices || []
  ).map((choice) => ({
    ...choice,
    isSelected: (choice as AnswerChoiceWithSelection).isSelected ?? false
  }))

  const selectedValues = answerChoicesWithSelection
    ?.filter((choice) => choice?.isSelected)
    ?.map((choice) => choice?.id)

  return (
    <>
      {isSingleChoice ? (
        <Radio.Group className="full-width" value={selectedValues?.[0]}>
          <Flex vertical gap={16}>
            {question?.answerChoices?.map((choice, index) => {
              const customId = choice?.id ?? index + 1

              return (
                <label key={customId}>
                  <Radio value={customId} />
                  <Text>{choice?.text?.[previewLang]}</Text>
                </label>
              )
            })}
          </Flex>
        </Radio.Group>
      ) : (
        <Checkbox.Group value={selectedValues} className="full-width">
          <Flex vertical gap={16}>
            {question?.answerChoices?.map((choice) => {
              return (
                <Checkbox key={choice.id} value={choice.id}>
                  <Text>{choice?.text?.[previewLang]}</Text>
                </Checkbox>
              )
            })}
          </Flex>
        </Checkbox.Group>
      )}
    </>
  )
}
